"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.swipable-area"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.metrics");

require("./style.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const isEqual = require('react-fast-compare');
/**
 * Stateless component to draw a claim
 * @param {array} slides array with info on a components structure like banner
 * @param {string} className className to help developer for styling
 * @param {bool} autoplay bool prop for autoplaying
 * @returns {JSX} Component JSX.
 */


class Carousel3D extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidMount", () => {
      let slides = [];
      this.props.slides.forEach(slide => {
        let slideobject = {
          class: 'slider-single proactivede',
          element: slide
        };
        slides.push(slideobject);
      });
      this.setState((prevState, props) => {
        return {
          slides,
          slideTotal: this.props.slides.length - 1
        };
      });

      if (this.state.slideCurrent === -1) {
        setTimeout(() => {
          this.slideRight();
        }, 500);
      }

      const {
        autoplay
      } = this.props;

      if (autoplay && autoplay > -1) {
        this.interval = setInterval(() => {
          this.slideRight();
        }, autoplay * 1000);
      }
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState, snapshot) => {
      if (prevProps.slides && prevProps.slides[0] && this.props.slides[0]) {
        if (!isEqual(prevProps.slides[0], this.props.slides[0])) {
          const slides = [];
          this.props.slides.forEach(slide => {
            const slideobject = {
              class: 'slider-single proactivede',
              element: slide
            };
            slides.push(slideobject);
          });
          this.setState(() => {
            return {
              slides,
              slideTotal: this.props.slides.length - 1,
              slideCurrent: -1
            };
          });
          this.setState(myPrevState => {
            return _objectSpread({}, myPrevState);
          });
          setTimeout(() => {
            this.slideRight();
          }, 500);
        }
      }
    });

    _defineProperty(this, "resetAllClassName", slide => {
      return slide.map(currentSlide => {
        const newCurretSlide = _objectSpread({}, currentSlide);

        newCurretSlide.class = '';
        return newCurretSlide;
      });
    });

    _defineProperty(this, "setSlidesClassName", (slide, slideCurrent, newNumber, number) => {
      slide.forEach((slid, index) => {
        const currentClassName = slid.class;
        /* STATUS MIDDLE */

        if (!currentClassName) {
          let class2Assign = ''; // deciding if pro or pre

          if (index < slideCurrent) {
            class2Assign = 'slider-single preactivede';
          } else {
            class2Assign = 'slider-single proactivede';
          }

          slide = this.setClass2Slider(slide, index, class2Assign);
        }
      });
      this.setState({
        slides: slide,
        slideCurrent
      }, () => {
        if (newNumber !== number) {
          this.goToSlide(number);
        }
      });
    });

    _defineProperty(this, "setClass2Slider", (slide, index, className) => {
      const newSlide = [...slide];
      newSlide[index].class = className;
      return newSlide;
    });

    _defineProperty(this, "goToSlide", number => {
      clearInterval(this.interval);
      const {
        slideTotal
      } = this.state;
      let {
        slideCurrent
      } = this.state;
      let newNumber = number;
      let way = '';

      if (typeof number === 'number') {
        // a laq ue quiero ir: number
        // en la que estoy: slideCurrent
        // el total: slideTotal
        // voy a la derecha:
        if (number - slideCurrent < 0 || number === slideTotal && slideCurrent === 0) {
          way = 'left';
        } else {
          way = 'right';
        }
      }

      let slide = [...this.state.slides];
      slide = this.resetAllClassName(slide);

      if (way === 'right') {
        slideCurrent = slideCurrent < slideTotal ? slideCurrent += 1 : 0;
        newNumber = slideCurrent;
        const activeSlideIndex = slideCurrent;
        slide = this.setClass2Slider(slide, activeSlideIndex, 'slider-single active');
        const preactiveSlideIndex = slideCurrent > 0 ? slideCurrent - 1 : slideTotal;
        slide = this.setClass2Slider(slide, preactiveSlideIndex, 'slider-single preactive');
        const proActiveSlideIndex = slideCurrent < slideTotal ? slideCurrent + 1 : 0;
        slide = this.setClass2Slider(slide, proActiveSlideIndex, 'slider-single proactive');
        this.setSlidesClassName(slide, slideCurrent, newNumber, number, way);
      }

      if (way === 'left') {
        slideCurrent = slideCurrent > 0 ? slideCurrent -= 1 : slideTotal;
        newNumber = slideCurrent;
        const activeSlideIndex = slideCurrent;
        slide = this.setClass2Slider(slide, activeSlideIndex, 'slider-single active');
        const preactiveSlideIndex = slideCurrent > 0 ? slideCurrent - 1 : slideTotal;
        slide = this.setClass2Slider(slide, preactiveSlideIndex, 'slider-single preactive');
        const proActiveSlideIndex = slideCurrent < slideTotal ? slideCurrent + 1 : 0;
        slide = this.setClass2Slider(slide, proActiveSlideIndex, 'slider-single proactive');
        this.setSlidesClassName(slide, slideCurrent, newNumber, number, way);
      }
    });

    _defineProperty(this, "slideRight", () => {
      const {
        slideTotal
      } = this.state;
      let {
        slideCurrent
      } = this.state;
      let preactiveSlide = null;
      let proactiveSlide = null;

      if (slideCurrent < slideTotal) {
        slideCurrent += 1;
      } else {
        slideCurrent = 0;
      }

      const slide = this.state.slides;

      if (slideCurrent > 0) {
        preactiveSlide = slide[slideCurrent - 1];
      } else {
        preactiveSlide = slide[slideTotal];
      }

      const activeSlide = slide[slideCurrent];

      if (slideCurrent < slideTotal) {
        proactiveSlide = slide[slideCurrent + 1];
      } else {
        proactiveSlide = slide[0];
      }

      slide.forEach(slid => {
        if (slid.class.includes('preactivede')) {
          slid.class = 'slider-single proactivede';
        }

        if (slid.class.includes('preactive')) {
          slid.class = 'slider-single preactivede';
        }
      });
      preactiveSlide.class = 'slider-single preactive';
      activeSlide.class = 'slider-single active';
      proactiveSlide.class = 'slider-single proactive';
      this.setState({
        slides: slide,
        slideCurrent
      });
    });

    _defineProperty(this, "renderDots", (slides, slideCurrent) => {
      const key = this.props.className ? '3dCarousel' : '';
      const {
        taggingInfo
      } = this.props;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "dots",
        children: slides.map((slide, index) => {
          const svgCss = index === slideCurrent ? ' single-dot--active' : ' single-dot--unactive';

          const customTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: `Bolita-ir-slide-${index}`,
            debug: true
          });

          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `single-dot${svgCss}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
              taggingInfo: customTaggingInfo,
              isBlockElement: true,
              onClick: () => {
                this.goToSlide(index);
              }
            })
          }, `${key}-${index.toString()}`);
        })
      });
    });

    _defineProperty(this, "buildTaggingInfo", (index, taggingInfo, eventType = 'click', way = 'left') => {
      return _objectSpread(_objectSpread({}, taggingInfo), {}, {
        eventType,
        componentContent: way === 'left' ? `Ir-Atras-${index}` : `Ir-Adelante-${index}`,
        debug: true
      });
    });

    _defineProperty(this, "renderSlides", (slides, nextSlide, backSlide) => {
      const {
        taggingInfo
      } = this.props;
      const prevTaggingInfo = this.buildTaggingInfo(backSlide, taggingInfo, 'click', 'left');
      const nextTaggingInfo = this.buildTaggingInfo(nextSlide, taggingInfo, 'click', 'right');
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        id: "swipable-carousel3d",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "slider-container",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "slider-content",
            children: slides.map((slider, index) => {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: slider.class,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "slider-single-content",
                  children: slider.element
                })
              }, `3d-slide-${index.toString()}`);
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          className: "slider_arrow slider_arrow--next",
          onClick: () => {
            this.goToSlide(nextSlide);
          },
          taggingInfo: nextTaggingInfo
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          className: "slider_arrow slider_arrow--back",
          onClick: () => {
            this.goToSlide(backSlide);
          },
          taggingInfo: prevTaggingInfo
        })]
      });
    });

    _defineProperty(this, "handleSwipe", (way = 'right', index) => {
      const {
        taggingInfo
      } = this.props;
      const newTaggingInfo = this.buildTaggingInfo(index, taggingInfo, 'swipe', way);
      (0, _gerenciatdUtils.sendCMSEvent)(newTaggingInfo);
      this.goToSlide(index);
    });

    this.state = {
      slideTotal: 0,
      slideCurrent: -1,
      slides: [],
      height: '0px',
      minHeight: props.minHeight || 0,
      autoplay: false
    };
  }

  render() {
    const {
      className,
      swipe,
      minimunSpace
    } = this.props;
    const classNameCss = className ? `${className} ` : '';
    const {
      slides,
      slideCurrent,
      minHeight
    } = this.state;
    const totalSlides = slides.length;
    const nextSlide = slideCurrent < totalSlides - 1 ? slideCurrent + 1 : 0;
    const backSlide = slideCurrent > 0 ? slideCurrent - 1 : totalSlides - 1;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `${classNameCss}react-3d-carousel`,
        style: {
          minHeight: `${minHeight}px`
        },
        children: [slides && totalSlides > 0 && swipe && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
          id: "swipable-carousel3d",
          onSwipeRight: () => {
            this.handleSwipe('right', nextSlide);
          },
          onSwipeLeft: () => {
            this.handleSwipe('left', backSlide);
          },
          minimunSpace: minimunSpace,
          children: this.renderSlides(slides, nextSlide, backSlide)
        }), slides && totalSlides > 0 && !swipe && this.renderSlides(slides, nextSlide, backSlide)]
      }), this.renderDots(slides, slideCurrent)]
    });
  }

}

_defineProperty(Carousel3D, "getDerivedStateFromProps", (props, state) => {
  if (props.minHeight > state.minHeight) {
    return _objectSpread(_objectSpread({}, state), {}, {
      minHeight: props.minHeight
    });
  }

  return _objectSpread({}, state);
});

Carousel3D.propTypes = {
  /**
   * {
   *  "info": "Define los slides del componente",
   *  "kind": "both",
   *  "beautifulName": "Slides"
   * }
   */
  slides: _propTypes.default.arrayOf(_propTypes.default.element),

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Define si hay autoplay, y de haberlo marca el tiempo de cambio de diapositiva. Por defecto -1, ej: 1 --> 1 segundo",
   *  "kind": "both",
   *  "beautifulName": "Autoplay"
   * }
   */
  autoplay: _propTypes.default.number,

  /**
   * {
   *  "info": "Activa la propiedad swipe del componente",
   *  "kind": "both",
   *  "beautifulName": "Swipe"
   * }
   */
  swipe: _propTypes.default.bool,

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object,

  /**
   * {
   *  "info": "Define el espacio mínimo para el componente",
   *  "kind": "both",
   *  "beautifulName": "Espacio mínimo "
   * }
   */
  minimunSpace: _propTypes.default.number
};
Carousel3D.defaultProps = {
  slides: [],
  className: null,
  autoplay: -1,
  swipe: true,
  taggingInfo: null,
  minimunSpace: 150
};
var _default = Carousel3D;
exports.default = _default;

//# sourceMappingURL=index.js.map